module.exports = __webpack_public_path__ + "img/order-btn-active.ff951231.png";